import React from 'react';
import { connect } from 'react-redux';
import {
  salesTypePageRequest,
  changeDateSalesType,
  changeOutletSalesType,
  exportSalesType,
} from 'actions/reports/sales';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild';
import { rupiahWithNegativeWithoutBracket } from 'utils/formatter';
import * as clevertapReportsSalesType from 'clevertap/reports/salesType';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import ActionBar from '../ActionBar';
import styles from './SalesType.css';
import BodyFrame from '../BodyFrame';

class SalesType extends React.Component {
  componentDidMount() {
    this.props.salesTypePageRequest();
  }

  render() {
    const { location, salesTypes, showLoadingSpinnerReport } = this.props;
    const [footBody, childBody] = this._formatDataForList();
    const showTable = salesTypes && salesTypes.length > 0;
    const hasNothingToShow =
      salesTypes && !salesTypes.length && !showLoadingSpinnerReport;

    return (
      <div id="reports-sales-type" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
        />
        <BodyFrame location={location}>
          <div className={styles.tableWrapper}>
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {showTable && (
              <TableWithoutChild
                headerBody={['Sales Type', 'Count', 'Total Collected']}
                childBody={childBody}
                footBody={footBody}
                tableClass={styles['sales-type-table']}
                headerBodyClassName={[
                  'header-name',
                  'header-rate',
                  'header-sales-type-collected',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-rate',
                  styles['body-sales-type-collected'],
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-rate',
                  styles['foot-sales-type-collected'],
                ]}
              />
            )}
            {hasNothingToShow && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _formatDataForList = () => {
    const { salesTypes, totalAmount } = this.props;
    const childBody = [];

    if (salesTypes) {
      salesTypes.forEach(function(st) {
        const { sales_type_name, sales_type_count, gross_sales } = st;

        childBody.push({
          sales_type_name,
          sales_type_count,
          gross_sales: rupiahWithNegativeWithoutBracket(gross_sales),
        });
      });
    }
    const footBody = {
      name: 'Total',
      total_amount: null,
      totalCollected: rupiahWithNegativeWithoutBracket(totalAmount),
    };
    return [footBody, childBody];
  };

  _onChangeOutlet = outletIds => {
    const { search, changeOutletSalesType } = this.props;
    const { startDate, endDate, startHour, endHour, allDay } = search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeOutletSalesType({
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { search, changeDateSalesType } = this.props;
    const { outlet } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    changeDateSalesType(formattedStart, formattedEnd, outlet);
  };

  _onClickExport = () => {
    const { search, exportSalesType } = this.props;
    const {
      outlet,
      date: { startDate, endDate, startHour, endHour, allDay },
    } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    const filename = `Report Sales Type - ${dateLabel}`;
    const query = {
      start: formattedStart,
      end: getFormattedEndDate(formattedEnd),
      outletIds: outlet,
      filename,
    };
    clevertapReportsSalesType.reportsSalesTypeExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    exportSalesType(query, filename, outlet[0]);
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const { showLoadingSpinnerReport, salesTypeReport } = state.reports.salesType;
  const { salesTypes, totalAmount } = salesTypeReport;
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    salesTypes,
    showLoadingSpinnerReport,
    totalAmount,
  };
}

const mapDispathToProps = {
  salesTypePageRequest,
  changeDateSalesType,
  changeOutletSalesType,
  exportSalesType,
};

export default connect(
  mapStateToProps,
  mapDispathToProps
)(SalesType);
